/* Optional presentation layer. Move existing nodes so their state and listeners survive. */
(() => {
  function init(root) {
    if (root.dataset.wideInitialized) return;
    const layout = root.querySelector('.bmp__layout');
    const nodes = ['.bmp__preview', '.bmp__summary-head', '.bmp__order-product'].map(s => root.querySelector(s));
    if (!layout || nodes.some(n => !n)) return;
    root.dataset.wideInitialized = 'true';
    const anchors = nodes.map(node => {
      const anchor = document.createComment('Original bunk layout position');
      node.before(anchor);
      return anchor;
    });
    const aside = document.createElement('aside');
    aside.className = 'bmp__desktop-preview bmp__card';
    aside.setAttribute('aria-label', 'Live bunk preview and price');
    const media = window.matchMedia('(min-width: 1100px)');
    function update() {
      if (media.matches) {
        nodes.forEach(node => aside.append(node));
        layout.append(aside);
        root.classList.add('bmp--wide');
      } else {
        nodes.forEach((node, i) => anchors[i].after(node));
        aside.remove();
        root.classList.remove('bmp--wide');
      }
    }
    media.addEventListener('change', update);
    update();
  }
  function scan() { document.querySelectorAll('[data-bunk-wide]').forEach(init); }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
